jQuery($ => {

    if ($('.o-featured-posts-slider')[0]) {
        $('.o-featured-posts-slider').each(function () {
            var slider = $(this).find('.m-post-thumbnail-cards--slider'),
                slides = slider.find('.m-post-thumbnail-cards__list'),
                arrowsNavigation = $(this).find('.o-featured-posts-slider__arrows-navigation');

            if (slider) {
                slides.slick({
                    speed: 400,
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    appendArrows: arrowsNavigation,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    }, {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                        }
                    }]
                });
            }
        });
    }

    if ($('.o-featured-posts--hide-posts')[0]) {
        $('.o-featured-posts__show-all').click(function () {
            const $section = $(this).closest('section');
            const $4thItem = $section.find('.m-post-tiles__item:nth-child(4)');

            $section.removeClass('o-featured-posts--hide-posts');
            $4thItem.find('.m-post-tile__wrapper').focus();
        });
    }

});